const avatarImgs = {
  user1: require('./avatar-mark-webber.webp'),
  user2: require('./avatar-angela-gray.webp'),
  user3: require('./avatar-jacob-thompson.webp'),
  user4: require('./avatar-rizky-hasanuddin.webp'),
  user5: require('./avatar-kimberly-smith.webp'),
  user6: require('./avatar-nathan-peterson.webp'),
  user7: require('./avatar-anna-kim.webp'),
};

export default avatarImgs;
